import React from 'react';
import { Container } from 'react-bootstrap';
import './Footer.css';

function Footer() {
  return (
    <div className="footer-wrapper">
      <Container>
        <p className="text-center text-muted mb-0">
          &copy; 2025 Hudson Condominium Solutions Inc.
        </p>
      </Container>
    </div>
  );
}

export default Footer;
